import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    LoggerContainerInfo,
} from 'app/Apps/ContainerManagement/Containers/containers.types'
import {
    NestedKeyOf,
} from 'app/types/utils.types'
import {
    LoggerType,
    LoggerConfiguration,
} from 'app/enums/label.enums'

const getColumns = (
    l: (key: string) => string,
): RichTableColumns<NestedKeyOf<LoggerContainerInfo>>[] => {
    return [
        {
            id: 'logger.loggerNumber',
            headerProps: {
                children: l('LOGGER'),
            },
            mapCellProps: 'logger.loggerNumber',
            minWidth: '150px',
        },
        {
            id: 'logger.loggerType',
            headerProps: {
                children: l('LOGGER_TYPE'),
            },
            mapCellProps: 'logger.loggerType',
            componentName: 'EnumValue',
            allowedValuesEnum: LoggerType,
            minWidth: '200px',
        },
        {
            id: 'isCurrentLogger',
            headerProps: {
                children: l('IS_CURRENT'),
            },
            mapCellProps: 'isCurrentLogger',
            componentName: 'Boolean',
            width: '90px',
        },
        {
            id: 'isDefaultLogger',
            headerProps: {
                children: l('IS_DEFAULT'),
            },
            mapCellProps: 'isDefaultLogger',
            componentName: 'Boolean',
            width: '90px',
        },
        {
            id: 'loggerPositionConfiguration',
            headerProps: {
                children: l('LOGGER_CONFIGURATION'),
            },
            mapCellProps: 'loggerPositionConfiguration',
            componentName: 'EnumValue',
            allowedValuesEnum: LoggerConfiguration,
            minWidth: '150px',
        },
        {
            id: 'exchangeTimestamp',
            headerProps: {
                children: l('EXCHANGE_TIMESTAMP'),
            },
            mapCellProps: 'exchangeTimestamp',
            minWidth: '200px',
            componentName: 'DateTimeCell',
        },
        {
            id: 'removedOn',
            headerProps: {
                children: l('REMOVED_ON'),
            },
            mapCellProps: 'removedOn',
            minWidth: '250px',
            componentName: 'DateTimeCell',
        },
    ]
}

export default getColumns
